import React from "react";
import {ChangePasswordModalState} from "../interfaces/ChangePasswordModalState";
import MarketRepository from "../../../../../Main/repository/MarketRepository";
import Toast from "../../../../../../utility/toast";
import AppSettingController from "../../../../../Main/controller/AppSettingController";
import i18n from "../../../../../../i18n";

export default class ChangePasswordModalController {
    protected state: ChangePasswordModalState;
    protected setState: React.Dispatch<React.SetStateAction<ChangePasswordModalState>>;

    constructor(state: ChangePasswordModalState, setState: React.Dispatch<React.SetStateAction<ChangePasswordModalState>>) {
        this.state = state;
        this.setState = setState;
    }

    async submitForm(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()

        const {prevPassword, newPassword, confirmNewPassword} = this.state;

        this.updateState({error: false})

        if (!this.initialValidation(prevPassword, newPassword, confirmNewPassword)) return

        if (!await this.validationPassword(newPassword, confirmNewPassword)) return

        Toast.success(i18n.t("toast.changePasswordSuccess"))
        window.dispatchEvent(new Event('closeModal'))
        return await AppSettingController.changePassword(prevPassword, newPassword)
    }

    async validationPassword(newPassword: string, confirmNewPassword: string) {
        const setting = MarketRepository.getSettingMarket();
        const hashPassword = await AppSettingController.passwordHash(this.state.prevPassword)

        // check prev password
        if (setting.password !== hashPassword) {
            this.updateState({
                error: true,
                message: i18n.t("setting.error.invalidCurrentPassword")
            });
            return false
        }

        // check new password
        if (newPassword !== confirmNewPassword) {
            this.updateState({
                error: true,
                message: i18n.t("setting.error.passwordMismatch")
            });
            return false
        }
        return true
    }

    initialValidation(prevPassword: string, newPassword: string, confirmNewPassword: string) {
        if (!prevPassword) {
            this.updateState({error: true, message: i18n.t("setting.error.currentPasswordRequired")});
            return false
        }
        if (!newPassword) {
            this.updateState({error: true, message: i18n.t("setting.error.newPasswordRequired")});
            return false
        }
        if (!confirmNewPassword) {
            this.updateState({error: true, message: i18n.t("setting.error.confirmPasswordRequired")});
            return false;
        }
        return true;
    }

    private updateState(state: object) {
        const newState = {...this.state, ...state};
        this.state = newState;
        this.setState(newState)
    }
}
